<div class="-business-type"
  [ngClass]="meta.type === 'marketplaces' ? '-marketplaces'
  : ''">
  <content-viewer
    *ngIf="body"
    [content]="body"
    (docRendered)="handleDocRendered($event)">
  </content-viewer>
</div>
